<template>
  <CygnusIcon :name="props.class" :style="{ color: colour }" />
</template>

<script setup>
// Formerly FontAwesomeIcon.vue — took an arbitrary raw FA class string (e.g.
// 'fa-heart', 'fal fa-server') and rendered it as a plain `<i>`. Renamed as
// part of the Cygnus icon set migration (icarus-core 3.1.0, FA fully
// removed). `props.class` is still whatever raw string a caller passes —
// `<CygnusIcon>`'s `resolveIconName` already knows how to parse a legacy
// FA-style class string down to a Cygnus icon name, so this keeps working
// for any existing caller without them needing to change what they pass.
import CygnusIcon from '@apexl/icarus-core/src/components/icons/CygnusIcon.vue';

const props = defineProps(
    {
      class: {
        type: String,
        required: true
      },
      colour: {
        type: String,
        required: false
      }
    }
)
</script>
